const actions = {

    async LINK_BUSINESS({rootState,dispatch},body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:'fondy/link',
                method:'POST',
                data:body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },
    async UNLINK_BUSINESS({rootState,dispatch},body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:'fondy/link',
                method:'DELETE',
                data:body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );
    },
    async GET_FONDY_CHECKOUT_URL({rootState,dispatch},body) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:'fondy/invoice',
                method:'POST',
                data:body,
                business : rootState.business.selectedBusiness.alias,
            }, {root : true}
        );

    },

}

export default {
    namespaced:true,
    actions,
}